"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandedFormOptionsCms = void 0;
var ExpandedFormOptionsCms = /** @class */ (function () {
    function ExpandedFormOptionsCms() {
        this.addCarrierInfoCTALabel = 'Add carrier info';
        this.updateCarrierInfoCTALabel = 'Update carrier info';
        this.addPreferredAreaCTALabel = 'Add preferred area code';
        this.updateAreaCodeCTALabel = 'Update preferred area code';
        this.callUsHelpLabel = 'Please call us at <strong>888.333.6651</strong>, so we can help with your order.';
        this.cancelLinkLabel = 'Cancel';
        this.continueCtaLabel = 'Continue';
    }
    return ExpandedFormOptionsCms;
}());
exports.ExpandedFormOptionsCms = ExpandedFormOptionsCms;
//# sourceMappingURL=ExpandedFormOptions.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/ExpandedFormOptions.cms.js
// module id = 2003
// module chunks = 8